import { render, staticRenderFns } from "./userTaskConf-view.vue?vue&type=template&id=ffb811ca&scoped=true"
import script from "./userTaskConf-view.vue?vue&type=script&lang=ts"
export * from "./userTaskConf-view.vue?vue&type=script&lang=ts"
import style0 from "./userTaskConf-view.vue?vue&type=style&index=0&id=ffb811ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb811ca",
  null
  
)

export default component.exports